import * as React from 'react';
import './eventDescription.module.scss';
import { MarkdownText } from '../../common/text/MarkdownText';
import { EventDetails } from '../../../types/event';

type Props = {
  event: EventDetails;
};
export class EventDescription extends React.Component<Props> {
  render() {
    const { event } = this.props;
    return (
      <div>
        <div styleName="header-sub">
          <MarkdownText source={event.introduction} />
        </div>
      </div>
    );
  }
}
